<template>
    <div class="left_panel custome_table_width manage_player-section">
        <div
            class="panel_head_wrap d-flex align-items-center justify-content-between"
        >
            <div class="panel_heading">
                <h2>Manage Player ({{ player_length }})</h2>
            </div>
            <div
                class="panel_head_right upload_img_panel d-flex align-items-center"
            >
                <router-link :to="{ name: 'AddNewPlayer' }" class="font_size_20"
                    >+ Add New Player
                </router-link>
            </div>
        </div>
        <div
            class="account_table manage_player_table table-responsive pl_10 pr_10 mt_30 mb_22 semibold-table custom_table_height_auto"
        >
            <table class="table mb_0">
                <thead>
                    <tr>
                        <th class="sort">
                            <SortIcons
                                :lable="'NAME'"
                                :listConfig="listConfig"
                                :sortBy="'first_name'"
                                @sorting="sorting($event)"
                            />
                        </th>
                        <th class="sort">
                            <SortIcons
                                :lable="'EMAILS'"
                                :listConfig="listConfig"
                                :sortBy="'email'"
                                @sorting="sorting($event)"
                            />
                        </th>
                        <th class="sort">
                            <SortIcons
                                :lable="'MOBILE'"
                                :listConfig="listConfig"
                                :sortBy="'mobile'"
                                @sorting="sorting($event)"
                            />
                        </th>
                        <th class="sort">TEAM</th>
                        <th scope="col">
                            <div
                                class="d-flex font_size_16 text_primary_blue text-uppercase"
                            >
                                Action
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(players, index) in players_list" :key="index">
                        <td>
                            <div class="font_size_16">
                                {{ players.first_name | capitalize }}
                                {{ players.last_name | capitalize }}
                            </div>
                        </td>
                        <td>
                            <div class="font_size_16">
                                <a :href="'mailto:' + players.email">{{
                                    players.email
                                }}</a>
                            </div>
                        </td>
                        <td>
                            <div class="font_size_16">
                                <a :href="'tel:' + players.mobile">{{
                                    players.mobile
                                }}</a>
                            </div>
                        </td>
                        <!-- <td v-if="players.Teams.length">
              <div class="font_size_16" v-for="(team,ind) in players.Teams" :key="ind">
                <a class="text_primary_blue" href="#">{{team.name}}</a>
              </div>
            </td>
            <td v-else>No Team Assign Yet</td> -->
                        <!-- <td>
               <router-link v-for="(team,ind) in players.Teams" :key="ind"
                                :to="{
                                  name: 'TeamMember',
                                  params: { id: team.id }
                                }"
                                class="link"
                              >
                                {{ team.name }}
                              </router-link>
            </td> -->
                        <td class="team_table-color">
                            <span
                                v-html="associateTeamsName(players.Teams)"
                            ></span>
                        </td>
                        <td>
                            <div class="d-flex align-items-center">
                                <span class="pr_16">
                                    <router-link
                                        v-tooltip="'Edit!'"
                                        :to="{
                                            name: 'EditPlayer',
                                            params: { id: players.id }
                                        }"
                                        class="mr-1 edit-link"
                                        ><img
                                            src="/maincss/images/icons/pen.svg"
                                    /></router-link>
                                </span>
                                <span>
                                    <a
                                        v-tooltip="'Delete!'"
                                        href="#"
                                        data-toggle="modal"
                                        :data-target="
                                            '#delete-resource-' + players.id
                                        "
                                        class="delete-link"
                                    >
                                        <img
                                            alt=""
                                            src="/maincss/images/icons/delete_dark.svg"
                                    /></a>
                                </span>
                            </div>
                        </td>
                        <DeleteResource
                            :target="'delete-resource-' + players.id"
                            :path="'/players/' + players.id"
                            @updatelist="getPlayers()"
                        />
                    </tr>
                </tbody>
            </table>
        </div>
        <VPagination :pages="pages" :currentPage.sync="currentPage" />
    </div>
</template>

<script>
import ApiService from "@/common/api.service";
import VPagination from "@/components/VPagination";
import SortIcons from "@/components/SortingIcons";
import DeleteResource from "@/components/DeletePopup";

export default {
    name: "ManagePlayer",
    components: { VPagination, SortIcons, DeleteResource },
    data() {
        return {
            players_list: [],
            player_length: 0,
            currentPage: 1,
            itemsPerPage: 10,
            listConfig: {
                offset: (this.currentPage - 1) * this.itemsPerPage,
                limit: this.itemsPerPage,
                sortBy: "",
                order: "ASC"
            }
        };
    },
    filters: {
        capitalize: function (value) {
            if (!value) {
                return "";
            }
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    },
    computed: {
        pages() {
            if (this.player_length <= this.itemsPerPage) {
                return [1];
            }
            return [
                ...Array(
                    Math.ceil(this.player_length / this.itemsPerPage)
                ).keys()
            ].map((e) => e + 1);
        }
    },
    watch: {
        currentPage(newValue) {
            this.listConfig.offset = (newValue - 1) * this.itemsPerPage;
            this.getPlayers();
        }
    },
    mounted() {
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });
        /* eslint-enable */
        this.listConfig = {
            offset: (this.currentPage - 1) * this.itemsPerPage,
            limit: this.itemsPerPage,
            sortBy: "id",
            order: "DESC"
        };
        this.getPlayers();
    },
    methods: {
        getPlayers() {
            let _this = this;
            _this.isLoader = true;
            new Promise(() => {
                ApiService.post("/all-players", _this.listConfig)
                    .then(({ data }) => {
                        _this.player_length = data.players.count;
                        _this.players_list = data.players.rows;
                        _this.isLoader = false;
                    })
                    .catch(({ response }) => {
                        console.log(response.status);
                    });
            });
        },
        associateTeamsName(teams) {
            if (teams.length > 0) {
                var teams_data = [];
                teams.forEach((element) => {
                    teams_data.push({ id: element.id, name: element.name });
                });
                teams_data = teams_data.map((elemet) => {
                    elemet.name = this.capitalFirstLetterOfEachWordString(
                        elemet.name
                    );
                    return elemet;
                });
                var a = "";
                for (let value of Object.values(teams_data)) {
                    a +=
                        '<a href="/teammember/' +
                        value.id +
                        '">' +
                        value.name +
                        "</a> ,";
                }
                a = a.replace(/,\s*$/, "");
                return a;
            } else {
                return "Team Not Assigned Yet";
            }
        },
        capitalFirstLetterOfEachWordString(value) {
            if (!value) {
                return "";
            }
            const arr = value.split(" ");
            for (var i = 0; i < arr.length; i++) {
                arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
            }
            const str2 = arr.join(" ");
            return str2;
        },
        sorting($event) {
            var _this = this;
            _this.listConfig.sortBy == $event.sortBy;
            _this.listConfig.order == $event.orderBy;
            _this.getPlayers();
        }
    }
};
</script>
